import {RedirectUrlComponent} from "../component/redirectUrlComponent";

export function configureRedirectController($scope, redirects, $mdDialog, LoaderService, ConfigurableRedirectService) {
    LoaderService.off();
    let originatorEv;
    $scope.redirections = redirects ? redirects : [];
    // $scope.addNewUrl = addNewUrl;

    $scope.showCreateNewModal = function (ev) {
        showRedirectDialog({}, ev, (newRedirect) => {
            $scope.redirections.push(newRedirect);
        });
    };

    $scope.editUrl = function (ev, r) {
        showRedirectDialog(r, ev, (changedRedirect) => {
            let idx = $scope.redirections.findIndex((filterRedirect) => {
                return filterRedirect.id === changedRedirect.id;
            });
            $scope.redirections[idx] = changedRedirect;
        });
    };

    $scope.deleteUrl = function (event, redirect) {
        ConfigurableRedirectService.deleteRedirect(redirect.id).then(
            (resp) => {
                if (resp.status === 200) {
                    $scope.redirections.splice($scope.redirections.indexOf(redirect), 1);
                }
            }
        )
    };


    function showRedirectDialog(redirectUrl, event, successCallback, errorCallback = function (e) {
        console.log(e);
    }) {
        $mdDialog.show({
            controller: RedirectUrlComponent,
            template: require('../component/redirect_url_component.html'),
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                configurableUrl: redirectUrl
            }
        }).then(successCallback, errorCallback);
    }

    $scope.openMenu = function ($mdMenu, ev) {
        originatorEv = ev;
        $mdMenu.open(ev);
    };

    function addNewUrl() {
        $scope.redirections.push({});
    }
}